export default __webpack_public_path__ + "static/media/playerHealthScore.2410a76c.png";